module.exports = __webpack_public_path__ + "assets/img/cloud4.7972b39f.png";